import { compose, withProps, branch, renderComponent } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  hasProviderProfileSelector,
  loggedUserIdSelector,
} from '../../../redux/context/selectors';
import { selectGuardianDependentsList } from '../../../redux/profiles/selectors';
import {
  selectUpcomingAppointmentsPending,
  selectUpcomingAppointmentList,
  selectUpcomingCount,
  selectHistoryCount,
  selectScheduledTasks,
  selectScheduledTasksCount,
  selectScheduledTasksPending,
  selectScheduledCompletedTasksCount,
  selectMetaAvailableUpcomingList,
  selectMetaAvailableScheduledTasks,
} from '../../../redux/healthboard/selectors';
import { actions as scheduledTasksActions } from '../../../redux/healthboard/requests/scheduled-tasks-upcoming-req';
import { actions as scheduledTasksCompletedActions } from '../../../redux/healthboard/requests/scheduled-tasks-completed-req';
import { actions as upcomingAppointmentActions } from '../../../redux/healthboard/requests/appointments-upcomming-req';
import { actions as historyAppointmentActions } from '../../../redux/healthboard/requests/appointments-history-req';
import { actions as defaultTab } from '../../../redux/ui/defaultTab';
import ProviderAppointmentList from '../ProviderAppointmentList';
import { dependentFormActions } from '../../../redux/dependentForm/progress.actions';

const mapStateToProps = state => ({
  scheduleTasks: selectScheduledTasks(state),
  scheduleTasksPending: selectScheduledTasksPending(state),
  scheduleTasksCount: selectScheduledTasksCount(state),
  loggedUserId: loggedUserIdSelector(state),
  dependentsList: selectGuardianDependentsList(state),
  completedTasksCount: selectScheduledCompletedTasksCount(state),
  appointmentLoading: selectUpcomingAppointmentsPending(state),
  appointmentList: selectUpcomingAppointmentList(state),
  upcomingAppointmentsCount: selectUpcomingCount(state),
  historyAvailableUpcomingList: selectMetaAvailableUpcomingList(state),
  historyAvailableScheduledTasks: selectMetaAvailableScheduledTasks(state),
  historyAppointmentsCount: selectHistoryCount(state),
  isProvider: hasProviderProfileSelector(state),
});

const mapDispatchToProps = {
  fetchScheduledTasks: scheduledTasksActions.send,
  fetchCompletedTasks: scheduledTasksCompletedActions.send,
  fetchUpcomingAppointments: upcomingAppointmentActions.send,
  fetchHistoryAppointments: historyAppointmentActions.send,
  setTab: defaultTab.setTab,
  setDependentSubmitRedirect: dependentFormActions.setSubmitRedirect,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ scheduleTasksPending, loadingAnsweredSurveys }) => ({
    pending: scheduleTasksPending || loadingAnsweredSurveys,
  })),
  branch(
    ({ isProvider }) => isProvider,
    renderComponent(ProviderAppointmentList),
  ),
);



// WEBPACK FOOTER //
// ./src/components/Healthboard/HealthboardHome/enhance.js